"use client";

import * as React from "react";
import { Activity, Dumbbell, HeartPulse, Trophy } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface SegmentItem {
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
const segments: SegmentItem[] = [{
  title: "Building Fitness",
  description: "For people starting or returning to structured exercise who want objective baseline measurements.",
  icon: Dumbbell
}, {
  title: "Healthy Ageing",
  description: "For people who want to maintain aerobic capacity, balance, movement and physical independence as they get older.",
  icon: HeartPulse
}, {
  title: "Active Adults",
  description: "For people already exercising who want better information about their fitness and movement.",
  icon: Activity
}, {
  title: "Athletes",
  description: "For recreational and competitive athletes wanting objective physiological and biomechanical measurements to support training decisions.",
  icon: Trophy
}];
export default function AudienceSegments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="audiencesegments" data-nav="light" ref={ref} className="relative bg-background text-foreground py-20 md:py-28 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-20 transition-all duration-700 ease-out" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground">
            Longevity and fitness are relevant at every age
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {segments.map((segment, index) => {
          const Icon = segment.icon;
          return <div key={segment.title} data-index={index} className="h-full transition-all duration-700 ease-out" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(24px)",
            transitionDelay: `${index * 100}ms`
          }}>
                <Card className="h-full border border-border/80 bg-card text-card-foreground shadow-xs hover:shadow-md hover:border-primary/40 transition-all duration-300 flex flex-col justify-between p-2">
                  <div>
                    <CardHeader className="space-y-4 pb-3">
                      <div className="size-11 rounded-lg bg-secondary flex items-center justify-center text-primary shrink-0">
                        <Icon className="size-5" />
                      </div>
                      <CardTitle className="text-xl font-semibold tracking-tight text-foreground">
                        {segment.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="pt-0">
                      <p className="text-muted-foreground text-sm leading-relaxed">
                        {segment.description}
                      </p>
                    </CardContent>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}